import { render, staticRenderFns } from "./AddMenuCatalog.vue?vue&type=template&id=cc2cddba&scoped=true"
import script from "./AddMenuCatalog.vue?vue&type=script&lang=js"
export * from "./AddMenuCatalog.vue?vue&type=script&lang=js"
import style0 from "./AddMenuCatalog.vue?vue&type=style&index=0&id=cc2cddba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2cddba",
  null
  
)

export default component.exports